import React from "react";
import spinnerImg from "@/Icons/spinner.png";

interface SpinnerProps {
  size?: number;
}

export const Spinner: React.FC<SpinnerProps> = ({ size = 42 }) => {
  return (
    <div className="spinner" style={{ width: size, height: size }}>
      <img src={spinnerImg} alt="Loading..." width={size} height={size} />
      <style>
        {`
        .spinner {
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}
      </style>
    </div>
  );
};
